
export const adminEmails = ["gprifte@arcatxp.com", "info@arcatxp.com"];
